
export default function ServiceDetailHead() {
  return (
    <>
    <section className="detailserv-head header-gap">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <span className="sub-tittle">Service</span>
                    <h1 className="heading">Turnkey Solutions</h1>
                    <p>End-to-end execution - from specification and manufacture to flawless installation and handover. We transform visions into fully realized interiors, ensuring every project is delivered seamlessly, beautifully, and on time.</p>
                </div>
    
            </div>
        </div>

        <img src="/image/turnkey-banner.webp" loading="lazy" className="img-responsive" alt="service"/>
    </section>  
    </>
  )
}
